export default {
  message: {
    type: 'countdown',
    raceId: 21,
    time: 1581942316,
    sentTime: 1581942216,
    delay: 74,
    tournamentId: 123,
    offer: {
      competitors: [
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
      ],
      nextEvent: {
        competitor1: {
          id: 1,
          name: 'Liki Nauda',
          odds: {
            current: 2.25,
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestRaces: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        competitor2: {
          id: 2,
          name: 'Riki Kaikkonen',
          odds: {
            current: 1.75,
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestRaces: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        headToHead: [
          13,
          34,
          34,
          13,
          34,
        ],
      },
      schedule: {
        eighthFinals: [
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
        ],
        quarterFinals: [
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
        ],
        semiFinals: [
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
        ],
      },
    },
    previousResults: [],
  },
  state: {
    type: 'countdown',
    delay: 28,
    raceId: 74,
    time: 1581942316,
    sentTime: 1581942216,
    tournamentId: 132,
    offer: {
      competitors: [
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 13,
          name: 'Liki Nauda',
          odds: {
            quarterFinals: null,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: {
            quarterFinals: null,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        {
          id: 34,
          name: 'Riki Kaikkonen',
          odds: null,
          latestResults: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
      ],
      nextEvent: {
        competitor1: {
          id: 1,
          name: 'Liki Nauda',
          odds: {
            current: 2.25,
            quarterFinals: 2.45,
            semiFinals: 2.25,
            finals: 6.35,
          },
          latestRaces: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        competitor2: {
          id: 2,
          name: 'Liki Nauda',
          odds: {
            current: 1.75,
            quarterFinals: 2.45,
            semiFinals: 1.75,
            finals: 5.35,
          },
          latestRaces: [
            {
              stage: 'semiFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
            {
              stage: 'quarterFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: false,
            },
            {
              stage: 'eighthFinals',
              won: true,
            },
          ],
        },
        headToHead: [
          13,
          34,
          34,
          13,
          34,
        ],
      },
      schedule: {
        eighthFinals: [
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
        ],
        quarterFinals: [
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
        ],
        semiFinals: [
          {
            raceId: 14,
            eventTime: 1579856014,
            competitor1: {
              id: 13,
              name: 'Liki Nauda',
              odds: 2.25,
            },
            competitor2: {
              id: 34,
              name: 'Riki Kaikkonen',
              odds: 1.75,
            },
          },
        ],
      },
    },
    previousResults: [],
  },
};
